import { getWindowObject } from '@eventbrite/feature-detection';
import { isDisplayRatingExperientEnabled } from './tracking/statsig';
import { RatingData } from './types';

export const getClampedValue = (value: number): number => {
    return value > 100 ? 100 : value < 0 ? 0 : value;
};

export const getPercentage = (value: number, total: number): number => {
    return (value * 100) / total;
};

export const getLocaleInfo = (): string => {
    return (
        getWindowObject('__SERVER_DATA__')?.env?.localeInfo?.locale || 'en_US'
    );
};

export const getSortedRatingCounts = (ratingData: RatingData) => {
    const {
        total_count: { value: totalCount, display: displayCount },
        rating,
        break_down: breakDown,
    } = ratingData;
    const ratingCounts = breakDown.sort(
        (a, b) => b.rating_star - a.rating_star,
    );
    return { ratingCounts, totalCount, displayCount, rating };
};

export const getDomain = () => {
    return getWindowObject('__SERVER_DATA__')?.env?.ebDomain;
};

export const capitalizeString = (string: string) => {
    return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
};

export const addPageToEvent = (event: string, page: string) => {
    return page ? `${capitalizeString(page)} - ${event}` : event;
};

export const getFilteredTrackingMethods = (
    methods: string[],
    filterList: string[],
) => {
    return methods.filter((item) => !filterList.includes(item));
};

export const evaluateExperiment = (
    rating: number,
    filterRating: boolean,
    statsigConfig: any,
) => {
    if (!filterRating) return true;
    if (statsigConfig) {
        const rangeToDisplay = statsigConfig.get('rangeToDisplay', null);
        const rangeToEvaluate = statsigConfig.get('rangeToEvaluate', null);
        const shouldDisplay =
            rangeToDisplay &&
            rating >= Number(rangeToDisplay?.from) &&
            rating <= Number(rangeToDisplay?.to);
        const shouldEvaluate =
            rangeToEvaluate &&
            rating >= Number(rangeToEvaluate?.from) &&
            rating < Number(rangeToEvaluate?.to) &&
            rangeToEvaluate?.experimentData &&
            isDisplayRatingExperientEnabled(rangeToEvaluate.experimentData);

        return shouldDisplay || shouldEvaluate;
    }
    return false;
};

export const isHexNumber = (hexNumber?: string) =>
    hexNumber && /^[0-9A-F]+$/gi.test(hexNumber);
